
/* a barra so aparece depois que o CTA do hero sai da tela */
(function(){
  var dock = document.getElementById('dock');
  var anchor = document.querySelector('.hero-copy .btn');
  if (!dock || !anchor) return;
  function sync(){ dock.classList.toggle('on', anchor.getBoundingClientRect().bottom < 0); }
  addEventListener('scroll', sync, {passive:true});
  addEventListener('resize', sync);
  sync();
})();
